/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';
import {
  Row,
  Column,
} from 'hedron';
import ds, { media } from 'designsystem';
import { WhiteArrow } from 'kentico-blocks/Calculator/styled';

const StyledRow = styled(Row)`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  z-index: 10;
  
  transform: ${({ show }) => (show ? 'translateY(0)' : 'translateY(100%)')};
  transition-duration: 0.4s;
`;

const StyledColumn = styled(Column)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${ds.brand('product')};
  padding: 0;
`;

const Value = styled.p`
  font-family: ${ds.get('type.fontFamily.headline')};
  line-height: ${ds.get('type.lineHeight.s')};
  font-size: ${ds.fs('l')};
  font-weight: ${ds.get('type.fontWeight.bold')};
  color: ${ds.brand('white')};
  text-align: center;
  margin-bottom: 0;
`;

const Unit = styled.span`
  font-family: ${ds.get('type.fontFamily.headline')};
  line-height: ${ds.get('type.lineHeight.s')};
  font-size: ${ds.fs('s')};
  font-weight: ${ds.get('type.fontWeight.bold')};
  color: ${ds.brand('white')};
`;

const ValueDescription = styled.p`
  font-family: ${ds.get('type.fontFamily.text')};
  line-height: ${ds.get('type.lineHeight.s')};
  font-size: ${ds.fs('s')};
  font-weight: ${ds.get('type.fontWeight.light')};
  color: ${ds.brand('white')};
  text-align: center;
  margin-top: 0;
`;

const ArrowLink = styled.button`
  font-family: ${ds.get('type.fontFamily.text')};
  line-height: ${ds.get('type.lineHeight.s')};
  font-size: ${ds.fs('base')};
  font-weight: ${ds.get('type.fontWeight.light')};
  color: ${ds.brand('white')};
  text-align: center;
  background: none;
  outline: none;
  cursor: pointer;
  border: none;
  transition-duration: 0.2s;
  margin-top: 0;
  margin-bottom: ${ds.get('metrics.s')};
  margin-left: ${ds.get('metrics.xs')};

  ${media.mobile`
    margin-left: ${ds.get('metrics.s')};
  `}

  &:hover {
    opacity: 0.7;
  }
`;

const MobileOptimisationModal = (
  {
    onClick,
    value,
    currency,
    period,
    description,
    linkText,
    show,
  },
) => (
  <StyledRow
    show={show}
  >
    <StyledColumn
      xsShift={3}
      xs={9}
      smShift={6}
      sm={6}
      mdShift={8}
      md={4}
    >
      <Value>
        {value}
        <Unit>
          {` ${currency} / ${period}`}
        </Unit>
      </Value>
      <ValueDescription>
        {`- ${description}`}
      </ValueDescription>
      <ArrowLink
        onClick={onClick}
      >
        {linkText}
        <WhiteArrow />
      </ArrowLink>
    </StyledColumn>
  </StyledRow>
);


export default MobileOptimisationModal;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Calculator/CalculatorMainView/MobileOptimisationModal/index.jsx